export function download(content: BlobPart, filename: string, contentType: string) {
	const a = document.createElement("a");
	const file = new Blob([content], { type: contentType });
	a.href = URL.createObjectURL(file);
	a.download = filename;

	a.click();

	URL.revokeObjectURL(a.href);
}
